import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import { Theme, StyleRulesCallback, withStyles, WithStyles } from '@material-ui/core/styles';

const styles: StyleRulesCallback<Theme, object> = (theme: Theme) => ({
    root: {
        marginTop: theme.spacing(2),
        width: "100%"
    }
});

type FormItemProps = WithStyles<"root">;

const FormItem: React.SFC<FormItemProps> = (props) => {
    const { classes } = props;

    return <Grid item className={classes.root}>{props.children}</Grid>
}

export default withStyles(styles)(FormItem);


// WEBPACK FOOTER //
// ./src/components/forms/FormItem.tsx